import { GeriBildirimPage } from './../pages/Yonetim/geri-bildirim/geri-bildirim';
import { KayitFormPage } from './../pages/ServisKayit/kayit-form/kayit-form';
import { HakkindaPage } from './../pages/hakkinda/hakkinda';
import { BllOrtak } from './../providers/bll/bll-ortak';
import { YonetimAnaSayfaPage } from './../pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { PersonelListesiPage } from './../pages/CariIslemleri/personel-listesi/personel-listesi';
import { HomePage } from './../pages/home/home';
import { PagesProvider } from './../providers/pages-provider';
import { EtiketbasPage } from './../pages/StokIslemleri/etiketbas/etiketbas';
import { ReportsPage } from './../pages/Raporlars/reports/reports';
import { SatispagePage } from './../pages/Muhasebe/Satis/satispage/satispage';
import { CarilerPage } from './../pages/CariIslemleri/cariler/cariler';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DalProvider } from './../providers/dal/dal';
import { M_SERVICE_INFO } from './../models/M_SERVICE_INFO';
import { BllServisBilgisi } from './../providers/bll-servis-bilgisi';
import { GirisPage } from './../pages/giris/giris';
import { Ortak } from './../providers/ortak';
import { StoklarPage } from './../pages/StokIslemleri/stoklar/stoklar';
import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events } from 'ionic-angular';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';
import { RaporAnaSayfaPage } from '../pages/Raporlars/rapor-ana-sayfa/rapor-ana-sayfa';


@Component({
  templateUrl: 'app.html',
  providers: [PagesProvider]
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  aranan = "";
  skip: number = 0;
  take: number = 50;
  rootPage: any = GirisPage;
  pages: any = [{ title: 'Ana Sayfa', component: HomePage, icon: "home", children: [] }];
  sol_segment: any;
  giderlistesi = [];
  gelirlistesi = [];
  KasaListesi=[];
  //islemyapan = this.ortak.storagePersonelGetir.Name;
  kasahareket: any = { ID: -1, KasaID: "", Tutar: "", SlsMan: "",AciklamaRef:"",CardRef:1};
  tahsilatAciklama="";
  constructor(public platform: Platform, public pagesProvider: PagesProvider,
    public androidFullScrenn: AndroidFullScreen,
    public ortak: Ortak, public dalProvider: DalProvider,
    public bllOrtak: BllOrtak,
    public splashScreen: SplashScreen,
     public events: Events,
  )
   {
    this.initializeApp();
    events.subscribe("leftMenu", () => {
      this.menuleriOlustur();
        });


    this.pages = [
      { title: 'Ana Sayfa', component: HomePage, icon: "home", children: [] },
      {
        title: 'Stok İşlemleri', component: null, icon: "archive",
        children: [
          { title: 'Malzemeler', component: StoklarPage, icon: "archive" },
          { title: 'Doğrudan stok Girişi', component: StoklarPage, icon: "barcode" },
          { title: 'Raf Etiketi Bas', component: EtiketbasPage, icon: "card" },
          { title: 'Satınalma Girişi', component: SatispagePage, icon: "briefcase" },
          { title: 'Satış Faturası', component: SatispagePage, icon: "briefcase" },

        ]
      },
      {
        title: 'Cari İşlemleri', component: null, icon: "people",
        children: [
          { title: 'Müşteriler', component: CarilerPage, icon: "person" },
          { title: 'Cari Hareketleri', component: CarilerPage, icon: "person" },

        ]
      },
      {
        children: [
          { title: 'Gün Sonu Raporu', component: ReportsPage, icon: "stats" },
          { title: 'Kasiyer Satış Raporu', component: CarilerPage, icon: "person" },
          { title: 'Karlılık Raporu', component: CarilerPage, icon: "person" },
          { title: 'Kategori Bazlı Satışlar', component: CarilerPage, icon: "person" },
          { title: 'Marka Bazlı Saytış', component: CarilerPage, icon: "person" },
          { title: 'Stok Durum Raporu', component: CarilerPage, icon: "person" },
          { title: 'Gider Raporu', component: CarilerPage, icon: "person" },
          { title: 'Gelir Raporu', component: CarilerPage, icon: "person" },
          { title: 'Kasa Durum Raporu', component: CarilerPage, icon: "person" },

        ]

      }

    ];

  }


  //   // used for an example of ngFor and navigation

  initializeApp() {
    this.platform.ready().then(() => {

      Ortak.sqlType = "web";
      var sqlDriver;
      if (Ortak.sqlType == "web") {
        sqlDriver = {
          database: "VT.db",
          type: "websql",
          storage: "web",
        };
      }
      else {
        sqlDriver = {
          database: "MRC_5.db",
          type: "websql",
          storage: "sqlite",

        };
      }
      this.dalProvider.createAndGetConnection(sqlDriver).then(a => {
        var bllServisBilgisi = new BllServisBilgisi();
        bllServisBilgisi.getAll().then(a => {
          var sonuc = <any>a;
          if (sonuc.length <= 0) {
            var servis = new M_SERVICE_INFO();
            servis.ADRES = "http://savcu.dnsservis.com";
            servis.VARSAYILAN = 1;
            servis.SERVIS_TANIMI = "SUNUCU";
            bllServisBilgisi.add(servis).then(b => {
              this.ortak.storageServisBilgisiEkle(servis);
              this.nav.setRoot(GirisPage);
            })
          }
          else {
            this.ortak.storageServisBilgisiEkle(a[0]);
            this.nav.setRoot(GirisPage);
            this.sol_segment="bilgi";
          }
        })
      })
      this.androidFullScrenn.isImmersiveModeSupported()
        .then(() => this.androidFullScrenn.immersiveMode())
        .catch((error: any) => console.log(error));

      // StatusBar.styleDefault();
      //StatusBar.styleLightContent();
      //StatusBar.backgroundColorByName("red")
      this.splashScreen.hide();
    });
    this.gideraciklamalari();
    this.geliraciklamalari();
    this.kasasecimi();
  }

  toggleSection(i) {
    if (this.pages[i].component != null) {
      this.openPage(this.pages[i])
    }
    else this.pages[i].open = !this.pages[i].open;
  }
  menuler = [];
  menuleriOlustur() {

    this.pagesProvider.menuler().then(a => {
      var sonuc = <any>a;
      this.menuler = sonuc.LEFT_MENU;
    })



  }

  openPage(menu) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    // this.nav.setRoot(page.component); ESKİ SAYFA
    var componentType = typeof menu.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = this.pagesProvider.components[menu.PAGE_COMPONENT];
    else
      component = menu.PAGE_COMPONENT;
    if (component == HomePage) {
      this.nav.setRoot(HomePage);
    }
    else {
      if (component == GirisPage) {
        //  this.ortak.storeagePersonelCikar();
      }
      this.nav.push(component);
    }
  }
  menuOpened(refresher) {

  }
  segmentChanged() {
    //yenileme işlemleri
  }
  menuClosed() {
    // this.menuOpened();
  }
  musteriyegit() {
    this.nav.push(CarilerPage);
  }
  malzemeler() {
    this.nav.push(StoklarPage);
  }
  PersonelPage() {
    this.nav.push(PersonelListesiPage);
  }
  raporlar() {
    this.nav.push(RaporAnaSayfaPage);
  }
  yonetimsayfasi() {
    this.nav.push(YonetimAnaSayfaPage);
  }
  hakkindasayfasi()
  {
   
    this.nav.push(HakkindaPage);
  }
  servisekle()
  {
    this.nav.push(KayitFormPage);
  }
  geribildirim()
  {
    this.nav.push(GeriBildirimPage);
  }

  giderekle() {
    if(this.kasahareket.Tutar==0||this.kasahareket.Tutar==null)
    {
      this.ortak.showBasicAlert("Uyarı","Lütfen Tutar ve gerekli alanları boş bırakmayınız")
    }
    else if(this.kasahareket.Tutar!=0||this.kasahareket.Tutar>=0)
    {
      var formData = new FormData();  
      this.kasahareket.SlsMan=this.ortak.storagePersonelGetir.Name;
        formData.append("Gider_json", JSON.stringify(this.kasahareket));
  
        this.bllOrtak.islem(formData, "GiderEkle", "", true).then(a => {
          var sonuc = <any>a;
          if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
          this.kasahareket.Tutar="";
          this.kasahareket.Text="";
          this.kasahareket.KasaID="";
          this.kasahareket.AciklamaRef="";
         
        })

    }
  
    }
  
  gelirekle() {
    if(this.kasahareket.Tutar==0||this.kasahareket.Tutar==null)
    {
      this.ortak.showBasicAlert("Uyarı","Lütfen Tutar ve gerekli alanları boş bırakmayınız")
    }
    else if(this.kasahareket.Tutar!=0||this.kasahareket.Tutar>=0)
    {
    var formData = new FormData();
    this.kasahareket.SlsMan=this.ortak.storagePersonelGetir.Name;
      formData.append("Gelir_json", JSON.stringify(this.kasahareket));
      this.bllOrtak.islem(formData, "GelirEkle", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        this.kasahareket.Tutar="";
        this.kasahareket.Text="";
        this.kasahareket.KasaID="";
        this.kasahareket.AciklamaRef="";

      
      })
    }
    }
  
  gideraciklamalari() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());

    this.bllOrtak.islem(formData, "GiderListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.giderlistesi = sonuc.SonucObject;
 
    })


  }
  geliraciklamalari() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "GelirListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.gelirlistesi = sonuc.SonucObject;

    })
  }
  kasasecimi()
  {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KasaListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.KasaListesi = sonuc.SonucObject;

    })

  }
  kapat()
  {
    this.ortak.showConfirmAlert("Uyarı", "Uygulama Kapanacak. Devam etmek istiyor musunuz?").then(k => {

      this.platform.exitApp();
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts